const Geocoder = (() => {
  // GeoNames account identifier (not a secret; required query param for the
  // free web service). Enable "Free Web Services" at geonames.org/manageaccount.
  const GEONAMES_USER = "ravicharme";

  let lastRequest = 0;

  function searchLocal(query) {
    const q = query.toLowerCase();
    return CITIES.filter(c =>
      c.name.toLowerCase().includes(q) ||
      c.nameEn.toLowerCase().includes(q)
    ).slice(0, 8).map(c => ({
      name: c.name,
      label: `${c.name} <small>${c.nameEn}, ${c.country}</small>`,
      lat: c.lat,
      lng: c.lng,
      tz: c.tz,
      source: "local"
    }));
  }

  function hasExactLocalMatch(query, localResults) {
    const q = query.toLowerCase();
    return localResults.some(r =>
      r.name.toLowerCase() === q ||
      r.name.toLowerCase().startsWith(q)
    );
  }

  async function searchGeoNames(query) {
    const now = Date.now();
    const wait = Math.max(0, 1000 - (now - lastRequest));
    if (wait > 0) await new Promise(r => setTimeout(r, wait));
    lastRequest = Date.now();

    // name_startsWith matches the literal place name, not a romanized
    // transliteration. GeoNames' default `q` search romanizes CJK input
    // ("草加" -> "caojia") and fuzzily matches unrelated places like the
    // Chinese 曹家/Caojia. Prefix-matching the name avoids that while still
    // returning legitimate foreign places typed in their own script.
    const params = new URLSearchParams({
      name_startsWith: query,
      maxRows: "5",
      lang: "ja",
      style: "full",
      orderby: "relevance",
      username: GEONAMES_USER
    });

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 3000);

    try {
      const res = await fetch(
        `https://secure.geonames.org/searchJSON?${params}`,
        { signal: controller.signal }
      );
      clearTimeout(timer);
      if (!res.ok) return [];
      const data = await res.json();
      if (!Array.isArray(data.geonames)) return [];

      return data.geonames.map(item => ({
        name: buildDisplayName(item),
        label: `${buildDisplayName(item)} <small>詳細検索</small>`,
        lat: parseFloat(item.lat),
        lng: parseFloat(item.lng),
        // GeoNames returns the per-location timezone, so the birth-time
        // calculation gets the correct offset even for multi-tz countries.
        tz: item.timezone && typeof item.timezone.gmtOffset === "number"
          ? item.timezone.gmtOffset
          : 9,
        source: "api"
      }));
    } catch {
      clearTimeout(timer);
      return [];
    }
  }

  function buildDisplayName(item) {
    const pref = item.adminName1 || "";
    const name = item.name || "";
    const parts = (pref && pref !== name) ? [pref, name] : [name];
    return parts.filter(Boolean).join(" ");
  }

  return { searchLocal, searchGeoNames, hasExactLocalMatch };
})();
